module.exports = __webpack_public_path__ + "static/media/koala-sling.e47ae2da.jpg";